"use client";

import styled from 'styled-components';
import { theme } from '@frameio/vapor-theme';

export const IconBefore = styled.div`
  display: flex;
  margin-left: calc(${theme.spaces[4]} * -1);
  margin-right: ${theme.spaces[4]};
`;

export const IconAfter = styled.div`
  display: flex;
  margin-left: ${theme.spaces[4]};
  margin-right: calc(${theme.spaces[4]} * -1);
`;
